/**
 * Zod input schemas: country. Split out of the one big schemas.ts (Oct 2026) so a session opens only the tool it
 * works on; nothing changed in the schemas themselves. Import as before, from '@daaily/shared' (or './schemas.js'
 * inside shared); the barrel re-exports every file in this folder. Shared primitives (EmailSchema, MonthSchema, …)
 * live in primitives.ts; cross-tool references are explicit imports between these files.
 */
import { z } from 'zod';
import { Iso3166CodeSchema, MoneyAmountSchema, ShortTextSchema } from './primitives.js';
// ===========================================================================
// COUNTRY
// ===========================================================================
export const CountryAdminEditSchema = z.object({
    code: Iso3166CodeSchema,
    name: ShortTextSchema,
    /** EUR rate for a 24-hour day spent fully in this country. */
    fullDayEur: MoneyAmountSchema,
    /** EUR rate for a partial (departure or return) travel day. */
    travelDayEur: MoneyAmountSchema,
    active: z.boolean(),
});
/** CSV variant — coerces numeric strings to numbers. */
export const CountryCsvRowSchema = z.object({
    code: Iso3166CodeSchema,
    name: ShortTextSchema,
    fullDayEur: z.coerce.number().pipe(MoneyAmountSchema),
    travelDayEur: z.coerce.number().pipe(MoneyAmountSchema),
    active: z.preprocess((v) => {
        if (typeof v === 'boolean')
            return v;
        if (v === '' || v == null)
            return true;
        if (typeof v === 'string')
            return v.toLowerCase() === 'true';
        return Boolean(v);
    }, z.boolean()),
});
//# sourceMappingURL=country.js.map